export const URL = {
  FETCH_PLATMAP_INFO: (
    areaName: string,
    communityName: string,
    neighborhoodName: string
  ) =>
    `${process.env.VUE_APP_BASEURL}/area/${areaName}/community/${communityName}/neighborhood/${neighborhoodName}`,

  FETCH_PLATMAPS_INFO: (areaName: string, communityName: string) =>
    `${process.env.VUE_APP_BASEURL}/area/${areaName}/community/${communityName}`,

  FETCH_HEADER: (neighborhoodId: string) =>
    `${process.env.VUE_APP_BASEURL}/neighborhood/${neighborhoodId}`,

  FETCH_FOOTER: (communityId: string, mode= 'customer') =>
    `${process.env.VUE_APP_BASEURL}/legend/community/${communityId}?mode=${mode}`,

  FETCH_PLATMAP: (neighborhoodId: string, communityCode: string) =>
    `${process.env.VUE_APP_BASEURL}/platmap/community/${communityCode}/neighborhood/${neighborhoodId}`,

  FETCH_PLATMAP_COORDINATES: (neighborhoodId: string) =>
    `${process.env.VUE_APP_BASEURL}/platmap/coordinate/neighborhood/${neighborhoodId}`,

  FETCH_HOME_PLANS: (neighborhoodId: string, communityCode: string) =>
    `${process.env.VUE_APP_BASEURL}/panel/community/${communityCode}/neighborhood/${neighborhoodId}`,

  FETCH_QMI_PLANS: (communityCode: string) =>
    `${process.env.VUE_APP_BASEURL}/s3/qmi/community/${communityCode}`,

  FETCH_LOT_INFO: (neighborhoodId: string, lotId: string, mode = 'customer') =>
    `${process.env.VUE_APP_BASEURL}/lot/${neighborhoodId}/${lotId}?mode=${mode}`,

  FETCH_AMINITY_INFO: (amenityId: string) =>
    `${process.env.VUE_APP_BASEURL}/amenity/${amenityId}`,

  FETCH_LOT_STATUS: (jobNumber: string) =>
    `${process.env.VUE_APP_BASEURL}/s3/job-status/${jobNumber}`,

  FETCH_LOTS: (neighborhoodId: string, neighborhoodType: string, mode = 'customer') =>
    `${process.env.VUE_APP_BASEURL}/lots/neighborhood/${neighborhoodId}?neighborhoodType=${neighborhoodType}&mode=${mode}`,

  SAVE_LEAD: () => `${process.env.VUE_APP_BASEURL}/lead`,

  PRINT_PDF: () => `${process.env.VUE_APP_BASEURL}/platmap/print`,

  FETCH_DIVISIONS: () => `/mock/areas.json`,

  FETCH_COMMUNITIES: (divisionId: string) => `/mock/communities.json`,

  PREVIEW_DATA: (communityCode: string) =>
    `${process.env.VUE_APP_BASEURL}/neighborhood/community/${communityCode}`,

  DIVISION_LIST: () => `${process.env.VUE_APP_BASEURL}/divisions`,

  COMMUNITIES_LIST: (code: string) =>
    `${process.env.VUE_APP_BASEURL}/communities/${code}`,

  NEIGHBORHOODS_LIST: () => `${process.env.VUE_APP_BASEURL}/neighborhoods`,

  FETCH_ELEVATIONS_DATA: (
    areaCode: string,
    neighborhoodCode: string,
    planCode: string
  ) =>
    `${process.env.VUE_APP_BASEURL}/elevation/area/${areaCode}/neighborhood/${neighborhoodCode}/plan/${planCode}`,
};
